import { Game } from './components/Game';
import './style.css';

export const App = () => (
  <div className="h-screen">
    <Game />
  </div>
);
